import { Box, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const TkLandingCards = ({ data }) => {
  const theme = useTheme();

  const getGridColumns = (dataLength) => {
    if (dataLength === 1) {
      return 'repeat(1, 1fr)';
    } else if (dataLength === 2) {
      return {
        xs: 'repeat(1, 1fr)',
        sm: 'repeat(2, 1fr)',
        md: 'repeat(2, 1fr)',
        lg: 'repeat(2, 1fr)',
        xl: 'repeat(2, 1fr)',
      };
    } else if (dataLength === 3) {
      return {
        xs: 'repeat(1, 1fr)',
        sm: 'repeat(2, 1fr)',
        md: 'repeat(2, 1fr)',
        lg: 'repeat(3, 1fr)',
        xl: 'repeat(3, 1fr)',
      };
    } else {
      return {
        xs: 'repeat(1, 1fr)',
        sm: 'repeat(2, 1fr)',
        md: 'repeat(2, 1fr)',
        lg: 'repeat(3, 1fr)',
        xl: 'repeat(4, 1fr)',
      };
    }
  };

  const displayType = { xs: 'grid', md: data.length > 2 ? 'grid' : 'flex' };
  const maxWidth = data.length > 2 ? '100%' : 385;

  return (
    <Box
      sx={{
        maxWidth: '100%',
        display: displayType,
        justifyContent: 'center',
        // gridTemplateColumns: 'repeat(auto-fill, 385px)',
        gridTemplateColumns: getGridColumns(data.length),
        gap: 2.5,
      }}
    >
      {data.map((e) => {
        return (
          <Box
            key={e.connected_platform_id}
            sx={{
              minHeight: 360,
              maxWidth: maxWidth,
              mb: 0.5,
              padding: 2,
              borderRadius: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              fontSize: '1.1em',
              border: 4,
              borderColor: e.accent_color,

              transition: 'all 0.35s ease',
              boxShadow: 5,
              '&:hover': {
                transform: 'translateY(-2px) scale(1.00)',
                cursor: 'pointer',
                boxShadow: 5,
              },
            }}
          >
            {/* logo */}
            <Box
              onClick={(event) => {
                event.stopPropagation();
                window.open(`${e.link_url}`, '_blank');
              }}
              sx={{ mb: 0.75 }}
            >
              <img
                src={e.logo_url}
                alt={`${e.name} logo`}
                style={{
                  objectFit: 'contain',
                  width: '100%',
                  height: '60px',
                }}
              />
            </Box>
            <Box
              onClick={(event) => {
                event.stopPropagation();
                window.open(`${e.link_url}`, '_blank');
              }}
              sx={{
                borderTop: 3,
                borderColor: e.accent_color,
                paddingTop: 1.75,
                maxHeight: '225px',
                overflow: 'auto',
                fontSize: '1.1rem',
                lineHeight: 1.6,
                px: 1,
                mb: 2,
                flex: 1,
                maskImage: 'linear-gradient(to bottom, black 60%, transparent 100%)',
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
                msOverflowStyle: 'none',
                scrollbarWidth: 'none',
                paddingBottom: '60px',
              }}
            >
              {e.paragraph_text}
            </Box>
            <Button
              fullWidth
              onClick={(event) => {
                event.stopPropagation();
                window.open(e.link_url, '_blank');
              }}
              sx={{
                color: '#fff',
                transition: 'all 0.35s ease',
                borderRadius: 1,
                backgroundColor: `${theme.palette.primary.main}`,
                '&:hover': {
                  backgroundColor: e.accent_color || theme.palette.accent.main,
                },
              }}
            >
              {e.button_text}
            </Button>
          </Box>
        );
      })}
    </Box>
  );
};

export default TkLandingCards;
